<template>
<v-card class="pa-6 pt-0 box-shadow-custom">
    <v-card-actions>
        <v-spacer></v-spacer>
        <span class="px-2">
            {{time}}
        </span>
    </v-card-actions>
    <v-form ref="form" v-model="valid" lazy-validation>
        <div class="py-3 mb-6 px-6 d-flex justify-space-between" style="align-items: center;">
            <div class="progress-bar" :class="OfferTest.link != null || OfferTest.link != '' ? 'active' : ''" style="background: #f3f3f30f;border: 1px solid #e1e1e1;padding: 0px 0px 10px 0px;border-radius: 8px;border-top: none;">
                <div>
                    <v-progress-linear style="border-radius: 15px; width: 300px; margin-bottom: 15px;" color="green" height="10" :value="progress.uploadLink">
                    </v-progress-linear>
                    <span><v-icon class="mr-2">mdi-link-variant</v-icon> Upload Links</span>
                </div>
            </div>
            <v-divider></v-divider>
            <div class="progress-bar" style="background: #f3f3f30f;border: 1px solid #e1e1e1;padding: 0px 0px 10px 0px;border-radius: 8px;border-top: none;">
                <v-progress-linear style="border-radius: 15px; width: 300px; margin-bottom: 15px;" color="green" height="10" :value="progress.uploadLink != 0 ? progress.runTest : 0">
                    </v-progress-linear>
                <span><v-icon class="mr-2">mdi-flash</v-icon>Run Test</span>
            </div>
            <v-divider></v-divider>
            <div class="progress-bar" style="background: #f3f3f30f;border: 1px solid #e1e1e1;padding: 0px 0px 10px 0px;border-radius: 8px;border-top: none;">
                <v-progress-linear style="border-radius: 15px; width: 300px; margin-bottom: 15px;" color="green" height="10" :value="progress.shareLink">
                    </v-progress-linear>
                <span><v-icon class="mr-2">mdi-share-variant</v-icon>Share Result</span>
            </div>
        </div>
        <v-row>
            <v-col cols="12" md="12">
                <v-text-field :disabled="IsTrue" v-model="OfferTest.link" :rules="Rules" class="ma-0 border-radius" prepend-inner-icon="mdi-link-variant" label="Enter your url" @click="isPaste" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <v-card :disabled="IsTrue" outlined class="py-md-0 px-md-4" style="padding: 12px !important;">
                    <v-row>
                        <v-col cols="12" md="6" class="py-0 d-flex align-center">
                            <span class="mb-2 mb-md-0 grey--text text--darken-1 text-capitalize">
                                <v-icon class="mr-2">mdi-cellphone-link</v-icon>
                                Device ( <b>{{devices[Device].text}}</b> )
                            </span>
                        </v-col>
                        <v-col cols="12" md="6" class="py-0 d-inline d-md-flex justify-end">
                            <v-btn-toggle dense v-model="Device" mandatory group>
                                <v-btn v-for="(i, index) in devices" :key="index" :class="i.value == 'windows_desktop' ? `primary--text` : i.value == 'android_phone' ? `success--text` : '' " @click="isDevice(index)" style="margin: 1px; width: 50px !important">
                                    <v-icon v-text="i.icon"></v-icon>
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
                <v-autocomplete v-model="OfferTest.country" attach @change="selectCity(OfferTest.country)" class="ma-0 border-radius" label="Country" :disabled="IsTrue" :rules="Rules" clearable :items="countryWithCode" outlined dense item-text="Country Name" item-value="Country" hide-details>
                    <template v-slot:item="{item}" style="text-transform: lowercase">
                        <span :class="`flag-icon flag-icon-${item.Country.toLowerCase()} mr-2`"></span>
                        <span>{{item["Country Name"]}}</span>
                    </template>
                    <template v-slot:selection="data">
                        <span :class="`flag-icon flag-icon-${data.item.Country.toLowerCase()} mr-2`"></span>
                        <span>{{data.item["Country Name"]}}</span>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col v-if="ItemDevices.ver != null" cols="12">
                <v-card outlined style="padding: 12px !important;" :disabled="IsTrue">
                    <v-row>
                        <v-col cols="12" md="6" class="py-0 d-flex align-center">
                            <span class="mb-2 mb-md-0 grey--text text--darken-1">
                                <v-icon class="mr-2">mdi-cellphone-link</v-icon>
                                OS Version ( <b>{{ItemDevices.ver[version]}}</b> )
                            </span>
                        </v-col>
                        <v-col cols="12" md="6" class="py-0 d-inline d-md-flex justify-end">
                            <v-btn-toggle dense v-model="version" class="flex-wrap" mandatory group>
                                <v-btn v-for="(i, index) in ItemDevices.ver" :key="index" class="text-lowercase" @click="isVer(index)" style="margin: 1px;">{{i}}</v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="switcher && userAccount.email.split('@')[1] == 'trackier.com'">
            <v-col cols="12" md="6" class="pb-0">
                <v-autocomplete v-model="OfferTest.city" class="ma-0 border-radius" attach :disabled="IsTrue" label="City (Optional)" prepend-inner-icon="mdi-city" :items="selectCityList" item-text="City" item-value="Parameter Value" outlined dense hide-details></v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="pb-0">
                <v-card-actions>
                    <template v-if="userAccount.email.split('@')[1] == 'trackier.com'">
                    <v-tooltip v-model="show" v-if="isSwitcher" top>
                        <template v-slot:activator="{ on }">
                            <span v-on="on">
                                <v-switch :disabled="isSwitcher" v-model="switcher" @change="onSwich" style="width: 190px" class="mt-0" color="primary" label="Advanced Option"></v-switch>
                            </span>
                        </template>
                        <span>Select country to enable advanced option</span>
                    </v-tooltip>
                    <v-switch v-else :disabled="isSwitcher" v-model="switcher" @change="onSwich" style="width: 190px" class="mt-0" color="primary" label="Advanced Option"></v-switch>
                    </template>
                    <v-spacer />
                    <v-icon color="primary" class="mr-2">mdi-history</v-icon>
                    <router-link class="hoverLink primary--text" to="/history">
                        <v-btn color="primary" outlined @click="fireEvent">Show History</v-btn>
                    </router-link>
                </v-card-actions>
            </v-col>
            <v-col cols="12" class="pb-0">
                <v-btn id="runTest" :loading="IsTrue" rounded color="primary" class="text-capitalize px-8" @click="runText">
                    <v-icon left>mdi-flash</v-icon><b>run test</b>
                    <template v-slot:loader>
                        <v-progress-circular :size="20" :width="1" indeterminate color="white"></v-progress-circular>
                        <span class="ml-2">Loading...</span>
                    </template>
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
    <Result v-if="offers != ''"  ref="toolbarChat" :isShow="true" :test="test" :offers='offers' />
</v-card>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from 'vuex'
import Vue from 'vue'
export default {
    components: {
        Result: () => import('@/components/Response/Results'),
    },
    data: () => ({
        isLogIn: false,
        ItemDevices: {
            'device': 'android_phone',
            "ver": [ '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0' ]
        },
        progress: {
            uploadLink: 0,
            runTest: 0,
            shareLink: 0
        },
        version: 6,
        time: null,
        menu2: false,
        modal2: false,
        Device: 3,
        show: false,
        snackbar: false,
        test: '',
        dialog: false,
        isSwitcher: true,
        switcher: false,
        network: [],
        offers: [],
        IsTrue: false,
        selectCityList: [],
        OfferTest: {
            link: '',
            platform: 'android_phone',
            country: "US",
            city: null,
            os_version: "10.0",
            isp: null
        },
        valid: true,
        Rules: [ v => !!v || 'field is required' ],
        search: null,
    }),
    computed: {
        ...mapGetters(['country', 'countryWithCode', 'devices', 'city', 'asn', 'userAccount'])
    },
    methods: {
        ...mapActions(['PostResponse', 'copy_link', 'TrackEvents']),
        ...mapMutations(['status_invalid', 'SnackbarSuccess', 'UserAccount']),
        isDevice(item) {
            if (this.devices[item].ver != null) {
                let selectedVersion = this.versionMapping(this.devices[item].ver)
                this.version = selectedVersion[this.devices[item].v_selected]
                this.ItemDevices = this.devices[item]
                this.OfferTest.platform = this.ItemDevices.value
                this.OfferTest.os_version = this.ItemDevices.ver[this.version]
            } else {
                this.version = this.devices[item].v_selected
                this.ItemDevices = this.devices[item]
                this.OfferTest.platform = this.ItemDevices.value
                this.OfferTest.os_version = this.ItemDevices.ver
            }
        },
        isVer(item) {
            this.OfferTest.os_version = this.ItemDevices.ver[item]
        },
        onSwich() {
            if (!this.switcher) {
                this.OfferTest.city = null
                this.OfferTest.isp = null
            }
        },
        selectCity(data) {
            if (data) {
                this.isSwitcher = false
                this.selectCityList = []
                this.network = []
                this.city.find(res => {
                    if (res.Country == data) {
                        this.selectCityList.push(res)
                    }
                })
                var match = "";
                this.asn.find(res => {
                    if (res.country == data) {
                        if (res.carrier != match) {
                            match = res.carrier
                            this.network.push(res.carrier)
                        }
                    }
                })
            }
        },
        async runText() {
            const withHttp = url => !/^https?:\/\//i.test(url) ? `http://${url}` : url;
            this.OfferTest.link = withHttp(this.OfferTest.link)
            if (localStorage.getItem('userToken')) {
                if (this.$refs.form.validate()) {
                    var urlR = /^https?:\/\//,
                        url = this.OfferTest.link.match(urlR);
                    if (url) {
                        this.IsTrue = true
                        this.isSwitcher = true
                        this.offers = []
                        try {
                            let value = {
                                url: '/internal/v2/test',
                                data: this.OfferTest
                            }
                            const data = (await this.PostResponse(value)).data
                            if (data.success) {
                                let final_status = data.data.result.redirects.slice(-1)[0].status;
                                if (data.data.result.redirects.slice(-1)[0] != undefined) {
                                    delete data.data.result.redirects.slice(-1)[0].time
                                    this.offers = data.data.result.redirects
                                }
                                this.test = {
                                    test_url: data.data.result.test_url,
                                    final_url: data.data.result.final_url,
                                    os_device: data.data.result.platform,
                                    os_version: data.data.result.os_ver,
                                    hops: data.data.result.hops,
                                    country: data.data.result.country,
                                    total_ms: data.data.result.total_ms,
                                    createdAt: data.data.result.test_time,
                                    _id: data.data.result.id,
                                    final_status: final_status
                                }
                                let dataMsg = {
                                    success: true,
                                    message: data.message,
                                    action: 'success'
                                }
                                this.progress.runTest = 100;
                                this.SnackbarSuccess(dataMsg)
                                localStorage.setItem("credit", JSON.stringify(data.data.credit))
                                this.UserAccount();
                                this.IsTrue = false
                                this.isSwitcher = false
                            } else {
                                let dataMsg = {
                                    success: true,
                                    message: data.message,
                                    action: 'error'
                                }
                                this.SnackbarSuccess(dataMsg)
                                this.IsTrue = false
                                this.isSwitcher = false
                            }
                        } catch (err) {
                            let dataMsg = {
                                success: true,
                                message: err.response.data.errors[0].message,
                                action: 'error'
                            }
                            this.SnackbarSuccess(dataMsg)
                            this.IsTrue = false
                            this.isSwitcher = false
                        }
                    } else {
                        let dataMsg = {
                            success: true,
                            message: ' Invalid URL',
                            action: 'error'
                        }
                        this.SnackbarSuccess(dataMsg)
                    }

                }
            } else {
                let value = {
                    success: false
                }
                this.status_invalid(value)
            }
        },
        versionMapping(item) {
            let selectedVersion = {};
            if (item) item.map((val, i) => selectedVersion[val] = i );
            return selectedVersion;
        },
        _history(history, device, selectedDevice) {
            let selectedVersion = this.versionMapping(history.ver);
            this.version = selectedVersion[this.$route.query.version];
            this.Device = selectedDevice[device];
            this.ItemDevices = this.devices[this.Device];
            this.OfferTest = {
                link: this.$route.query.url,
                platform: device,
                country: this.$route.query.country,
                os_version: this.$route.query.version,
                isp: null,
                city: null
            }
            this.TrackEvents({ event_name: 'test_history', action: "test" })
            this.selectCity(this.OfferTest.country)
        },
        historyTest() {
            if (this.$route.query) {
                let selectedDevice = {}, devices = this.devices, device = this.$route.query.device;
                devices.find((key, i) => { selectedDevice[key.value] = i });
                let history = devices.find((res) => res.value === device);
                if (history) {
                    this._history(history, device, selectedDevice);
                } else {
                    let response = devices[this.Device];
                    let selectedVersion = this.versionMapping(response.ver);
                    let version = response.v_selected;
                    this.version = selectedVersion[version];
                    this.ItemDevices = response;
                }
            } else {
                this.OfferTest = {}
            }
        },
        isPaste() {
            navigator.clipboard.readText()
                .then(text => {
                    var urlR = /^https?:\/\//;
                    var url = text.match(urlR);
                    if (url[0] == "https://" || url[0] == "http://") {
                        this.OfferTest.link = url.input;
                    }
                })
                .catch(() => {
                    return false
                });
        },
        checkOutLog() {
            if (localStorage.getItem('user')) {
                this.isLogIn = false
            } else {
                this.isLogIn = true
            }
        },
        fireEvent() {
            this.TrackEvents({ event_name: 'linktest', action: "history" })
        }
    },
    watch: {
        'OfferTest.link'(val) {
            if (val) {
                this.progress.uploadLink = 100;
            } else {
                this.progress.uploadLink = 0;
            }
        },
    },
    mounted() {
        this.$root.$on('progressUpdate', (type, number) => {
            this.progress[type] = number;
        })
        this.$root.$on('LogChange', () => {
            this.checkOutLog()
        })
        this.selectCity(this.OfferTest.country)
        this.historyTest()
        this.checkOutLog()
        let runTest = this.$route.query && this.$route.query.runTest ? this.$route.query.runTest : null;
        if (runTest == "1") {
            setTimeout(() => {
                document.getElementById("runTest").click();
            }, 2000)
        }
    }
}
</script>


<style scoped>
.progress-bar {
    text-align: center;
}
.custom-circul {
    border: 1px solid black;
    padding: 14px;
    border-radius: 50px;
    width: 57px;
    display: flex;
    justify-content: center;
    /* margin-right: 80px; */
}
.custom-circul-header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-right: 20px;
}
</style>